module.exports = __webpack_public_path__ + "static/media/batch-load-sample.cc22fbc1.csv";